import { render, staticRenderFns } from "./Amounts.vue?vue&type=template&id=7561be56&scoped=true"
import script from "./Amounts.vue?vue&type=script&lang=js"
export * from "./Amounts.vue?vue&type=script&lang=js"
import style0 from "./Amounts.vue?vue&type=style&index=0&id=7561be56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7561be56",
  null
  
)

export default component.exports